import React, { useEffect, useState } from "react";
import moment from "moment";

import { useAuth } from "../../../../context/AuthProvider";
import { useNotification } from "../../../../context/NotificationProvider";
import { useLocalization } from "../../../../context/LocalizeContextProvider";

import { getPatientPackages } from "../../../../services/Handlers/PackageService";

import PatientPackageComponents from "../components";
import { PER_PAGE_SIZE } from "../../../../utils/constants";
import { useMutation } from "@tanstack/react-query";

const defaultFilter = {
  type: { label: "Harian", value: "day" },
  from: moment().startOf("month").format("YYYY-MM-DD"),
  to: moment().endOf("month").format("YYYY-MM-DD"),
  page: 0,
  size: PER_PAGE_SIZE,
  identity_number: null,
  name: null,
  phone_number: null,
  date_of_birth: null,
  busines_id: null,
  current_utc: null,
};

export default function PatientPackage() {
  const { userDetail } = useAuth();
  const notification = useNotification();
  const localize = useLocalization();

  const [filterPackage, setFilterPackage] = useState(
    JSON.parse(JSON.stringify(defaultFilter))
  );
  const [totalPage, setTotalPage] = useState(0);
  const [totalEntries, setTotalEntries] = useState(0);
  const [dataPatientPackage, setDataPatientdataPatientPackage] = useState([
    {
      id: null,
      identity_number: null,
      name: null,
      phone_number: null,
      date_of_birth: null,
      last_reservation_date: null,
      isMoreThanOneMonth: false,
    },
  ]);

  const { isLoading, mutate: mutatePatientPackage } = useMutation(
    ["GetPatientPackage"],
    (data) => getPatientPackages(data),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          if (res?.data?.data.length > 0) {
            const datePackage = res?.data.data.map((item) => ({
              ...item,
              last_reservation_date: moment(
                item.last_reservation_date,
                "DD-MM-YYYY"
              ).format("DD MMM YYYY"),
              isMoreThanOneMonth:
                moment().diff(
                  moment(item.last_reservation_date, "DD-MM-YYYY"),
                  "months",
                  true
                ) > 1,
            }));

            setDataPatientdataPatientPackage(datePackage || []);
          } else {
            setDataPatientdataPatientPackage([]);
          }
          setTotalEntries(res?.data?.total);
          setTotalPage(Math.ceil(res?.data?.total / filterPackage.size));
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
    }
  );

  useEffect(() => {
    if (userDetail?.businessId) {
      mutatePatientPackage({
        ...filterPackage,
        busines_id: userDetail.businessId,
      });
    }
    // eslint-disable-next-line
  }, [userDetail]);

  const handleChangeFilter = async (name, value) => {
    if (
      name === "from" &&
      filterPackage.to &&
      moment(value, "YYYY-MM-DD").isAfter(
        moment(filterPackage.to, "YYYY-MM-DD")
      )
    ) {
      await setFilterPackage((prevState) => ({
        ...prevState,
        to: null,
      }));
    }

    setFilterPackage((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClickFilter = () => {
    handleChangeFilter("page", 0);
    mutatePatientPackage({
      ...filterPackage,
      page: 0,
      busines_id: userDetail.businessId,
    });
  };

  const handleChangeSizePerPage = (size) => {
    handleChangeFilter("size", size);
    handleChangeFilter("page", 0);
    mutatePatientPackage({
      ...filterPackage,
      size,
      page: 0,
      busines_id: userDetail.businessId,
    });
  };

  const handlePagination = (value) => {
    handleChangeFilter("page", value);
    mutatePatientPackage({
      ...filterPackage,
      page: value + 1,
      busines_id: userDetail?.businessId,
    });
  };

  const handleClearFilter = async () => {
    await setFilterPackage({
      ...defaultFilter,
      busines_id: userDetail.businessId,
    });
    mutatePatientPackage({
      ...defaultFilter,
      busines_id: userDetail.businessId,
    });
  };

  return (
    <PatientPackageComponents
      isLoading={isLoading}
      filterPackage={filterPackage}
      dataPatientPackage={dataPatientPackage}
      totalPage={totalPage}
      totalEntries={totalEntries}
      handleChangeFilter={handleChangeFilter}
      handleClearFilter={handleClearFilter}
      handlePagination={handlePagination}
      handleChangeSizePerPage={handleChangeSizePerPage}
      handleClickFilter={handleClickFilter}
    />
  );
}
